


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class StarRating extends Vue {
  @Prop() private rating!: number;
  private value: number = 5;

  @Watch('rating', {immediate: true})
  private onRatingChange() {
    Vue.set(this, 'value', this.rating);
  }

  private onValueChange(val: number[]) {
    this.$emit('update:rating', val);
  }
}
